import * as React from 'react';
import * as classes from '@common/components/modal/_components/modal.scss';

type AnyComponent<P> = string | React.ComponentClass<P> | React.StatelessComponent<P>;
interface ModalChildProps extends React.Attributes {
  buttonRef: (button: HTMLButtonElement) => void;
  saveCallback: Function | undefined;
  isModal: boolean;
}

export interface ModalProps<P = {}> {
  readonly title: string;
  readonly component: AnyComponent<P>;
  readonly closeModal?: () => void;
  readonly saveCallback?: Function;
  readonly childProps?: Partial<P>; // props to pass to the child
  readonly bodyClasses?: string; // override the styles of the body component
  readonly hideClose?: boolean;
  readonly hideSave?: boolean;
  readonly hideX?: boolean;
  readonly saveLabel?: string;
  readonly closeLabel?: string;
  readonly closeCallback?: Function; // triggers always when the component unmounts
  readonly clickClose?: Function; // triggers if someone clicks the close button
  readonly isSmall?: boolean;
}

export class ModalComponent<P extends ModalChildProps> extends React.Component<ModalProps<P>> {
  private button: HTMLButtonElement;

  constructor(props: ModalProps<P>) {
    super(props);
  }

  componentDidMount() {
    setTimeout(() => {
      const elts = window.document.getElementsByClassName(classes.dialog);
      if (elts.length > 0) {
        elts[0].className = [classes.dialog, classes.open].join(' ');
      }
    }, 50);
  }

  componentWillUnmount() {
    if (this.props.closeCallback) {
      return this.props.closeCallback();
    }
  }

  validate() {
    if (this.button) {
      return this.button.click();
    }

    if (this.props.saveCallback) {
      return this.props.saveCallback();
    }
  }

  close() {
    if (this.props.clickClose) {
      this.props.clickClose();
    }
    if (this.props.closeModal) {
      this.props.closeModal();
    }
  }

  render() {
    let childProperties: P = {
      ...(this.props.childProps! as Object),
      buttonRef: (button: HTMLButtonElement) => {
        this.button = button;
      },
      saveCallback: this.props.saveCallback,
      isModal: true
    } as P;

    let childComponent = React.createElement<P>(this.props.component, childProperties);

    let closeButton = undefined;
    if (!this.props.hideClose) {
      closeButton = (
        <button
          type="button"
          className="btn btn-secondary pull-left"
          onClick={() => {
            this.close();
          }}
        >
          {this.props.closeLabel || 'Close'}
        </button>
      );
    }

    let saveButton = undefined;
    if (!this.props.hideSave) {
      saveButton = (
        <button
          className="btn btn-primary pull-right"
          onClick={() => {
            this.validate();
          }}
        >
          {this.props.saveLabel || 'Save'}
        </button>
      );
    }

    return (
      <div>
        <div className={classes.backdrop} />
        <div className={classes.modal}>
          <div className={classes.dialog}>
            <div className={classes.content}>
              <div className={classes.header}>
                {!this.props.hideX && (
                  <button type="button" onClick={this.props.closeModal} className={classes.close}>
                    <span>X</span>
                  </button>
                )}
                <h5 className={classes.title}>{this.props.title}</h5>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div
                    className={
                      this.props.bodyClasses
                        ? this.props.bodyClasses
                        : this.props.isSmall
                          ? [classes.body, classes.small].join(' ')
                          : classes.body
                    }
                  >
                    {childComponent}
                  </div>
                </div>
              </div>
              <div className={classes.footer}>
                {closeButton}
                {saveButton}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/modal/_components/modal.component.tsx